import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronRight } from "lucide-react";

export function FAQ({ t }) {
  const items = [
    { q: t.faq.q1, a: t.faq.a1 },
    { q: t.faq.q2, a: t.faq.a2 },
    { q: t.faq.q3, a: t.faq.a3 },
    { q: t.faq.q4, a: t.faq.a4 },
    { q: t.faq.q5, a: t.faq.a5 },
  ];
  const [open, setOpen] = useState(0);
  return (
    <section className="py-12 lg:py-28" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-[#292524] mb-6 lg:mb-10 leading-tight">
          {t.faq.title}
        </h2>
        <div className="space-y-3">
          {items.map((it, i) => (
            <div
              key={i}
              className="card !p-0 overflow-hidden"
              data-testid={`faq-item-${i}`}
            >
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                data-testid={`faq-toggle-${i}`}
                className="w-full text-left px-6 py-5 flex items-center justify-between gap-4 hover:bg-[#FAF6F0] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#D95D39]/40 focus-visible:ring-offset-0 rounded-2xl"
              >
                <span className="font-heading font-semibold text-lg text-[#292524]">{it.q}</span>
                <ChevronRight
                  className={`w-5 h-5 text-[#D95D39] transition-transform ${
                    open === i ? "rotate-90" : ""
                  }`}
                />
              </button>
              <AnimatePresence>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.25 }}
                    className="overflow-hidden"
                  >
                    <div className="px-6 pb-5 text-[#57534E] leading-relaxed">{it.a}</div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
